import $ = require('jquery');
import DragDrop = require('diy/common/js/dd/DragDrop');
import DropZone = require('diy/common/js/dd/DropZone');
import NavDropZone = require('./dd/NavDropZone');
import MainNavDropZone = require('./dd/MainNavDropZone');
import SubNavDropZone = require('./dd/SubNavDropZone');
import MatrixDropZone = require('./dd/MatrixDropZone');
import ModuleDragSource = require('./dd/ModuleDragSource');
import ExistingModuleDragSource = require('./dd/ExistingModuleDragSource');
import ExistingModuleHelper = require('./dd/ExistingModuleHelper');

interface NavData {
    pageId: number;
    parentId: number;
    title: string;
}

interface PageData {
    pageId: number;
    label: string;
    items?: PageData[];
}

interface PageDataMap {
    [pageId: number]: PageData[];
}

/**
 * Module drag & drop logic
 *
 * Adds drag & drop functionality to all existing modules found within a matrix. Allows modules
 * to be moved between matrixes or dropped to a different page.
 */
    class ModuleDragDrop extends DragDrop {
        private hoverBlockOverlay: JQuery;
        private hoverBlockOverlayZindex = 100200;
        private dragHelper: ExistingModuleHelper;
        private pagesMap: PageDataMap;
        /**
         * Bootstrap
         */
        init() {
            this.initDragHelper();
            this.addMatrixZones();
            this.setUpRefreshListeners();
            this.prepareNavigationData(jimdoData.navigation.pages);
        }
        /**
         * Adds existing modules to the drag and drop manager
         */
        initDragHelper() {
            this.dragHelper = new ExistingModuleHelper();
        }
        addDragSourceEl(dragSourceEl: JQuery) {
            let dragSource = new ExistingModuleDragSource(dragSourceEl);
            dragSource.setHelper(this.dragHelper);
            this.addDragSource(dragSource);
        }
        /**
         * Adds matrix drop targets to the manager, which need to be initialized
         * before the drag starts or else draggables can't connect to them
         */
        addMatrixZones() {
            $('.sortable-matrix').each((index, elem) => {
                this.addDropZone(new MatrixDropZone($(elem)));
            });
        }
        addNavZones() {
            if (!diy.editor.uiPreference.isPointerModeTouch()) {
                // Disable drag and drop over navigation on touch devices because
                // it causes big performance problems
                $('#mainNav1 a, #mainNav2 a, #mainNav3 a, #dropdownmenu > li > a')
                    .each((index, elem) => {
                        this.addDropZone(new MainNavDropZone($(elem)));
                    });
            }
        }
        onDragStart(e: JQueryEventObject, ui: {}, dragSource: ModuleDragSource) {

            //signal generic dragstart event
            $(document).trigger("diy-siteadmin-item-dragstart");

            this.createHoverBlockOverlay();
            this.addNavZones();
            super.onDragStart(e, ui, dragSource);
        }

        onDragStop(e: JQueryEventObject, ui: {}, dragSource: ModuleDragSource) {

            //signal generic dragstop event
            $(document).trigger("diy-siteadmin-item-dragstop");

            super.onDragStop(e, ui, dragSource);
            this.removeDropZones(function(zone) {
                return zone instanceof NavDropZone;
            });
            this.removeHoverBlockOverlay();
        }

        onDropZoneChanged(newDropZone: DropZone, oldDropZone: DropZone) {
            super.onDropZoneChanged(newDropZone, oldDropZone);

            if (oldDropZone instanceof MainNavDropZone) {
                if (oldDropZone.element.is(":diy-dropdownmenu")) {
                    oldDropZone.element.diy_dropdownmenu('delayHide');
                }
            }

            if (newDropZone instanceof MainNavDropZone) {

                let position = {
                    collision: 'flip flip',
                    offset: '0 0'
                };
                if (newDropZone.isVerticalNav()) {
                    $.extend(position, {
                        my: 'left top',
                        at: 'right top'
                    });
                } else {
                    $.extend(position, {
                        my: 'left top',
                        at: 'left bottom'
                    });
                }

                let subPageItems = this.getPageNavigationItems(newDropZone.getPageId());
                if (subPageItems && subPageItems.length) {
                    if (!newDropZone.element.is(':diy-dropdownmenu')) {
                        newDropZone.element.diy_dropdownmenu({
                            zIndex: this.hoverBlockOverlayZindex + 1,
                            cls: 'diye-subpages-menu',
                            position: position,
                            items: subPageItems,
                            showDelay: 1000,
                            hideDelay: 200
                        });

                        newDropZone.element.on(
                            'dropdownmenushow dropdownmenuhide dropdownmenuexpand',
                            () => {
                                //Hack to refresh jquery ui droppable positions on demand
                                (<any>$.ui).ddmanager.prepareOffsets(
                                    this.currentDragSource.element.data('uiDraggable')
                                );
                            }
                        );

                        newDropZone.element.diy_dropdownmenu('render');
                        let items = newDropZone.element.diy_dropdownmenu('getItems');
                        let dropZone: SubNavDropZone;
                        let el: JQuery;
                        for (let i = 0; i < items.length; i++) {
                            el = items[i].el.children('a');
                            el.attr('data-page-id', items[i].data.pageId);
                            dropZone = new SubNavDropZone(el);
                            dropZone.setParentNavZone(newDropZone);
                            this.addDropZone(dropZone);
                            dropZone.activate();
                        }
                    }

                    newDropZone.element.diy_dropdownmenu('delayShow');
                }
            } else if (newDropZone instanceof SubNavDropZone) {
                newDropZone.getParentNavZone().element.diy_dropdownmenu('cancelHide');
            }

        }
        onDropZoneOver(e: JQueryEventObject, ui: {}, dropZone: DropZone) {
            super.onDropZoneOver(e, ui, dropZone);

            if (dropZone instanceof MatrixDropZone && this.currentDropZone !== dropZone) {
                //we hide the invitation manually whenever we hover a matrix
                //because the sortable automatically shows the placeholder by default
                dropZone.hideInvitation();
            }
        }
        getPageNavigationItems(pageId: number) {
            return this.pagesMap[pageId];
        }
        /**
         * Build a tree structure containing all the page hierarchy, needed
         * for the subpage dropdown menu. Also maintains a map of pages by
         * parent page id
         */
        prepareNavigationData(navData: NavData[]) {
            let subPages: PageDataMap = {};
            let pagesMap: PageDataMap = {};

            for (let i = 0; i < navData.length; i++) {
                let pId = navData[i].parentId;
                subPages[pId] = subPages[pId] || [];
                subPages[pId].push({
                    label: navData[i].title,
                    pageId: navData[i].pageId
                });
            }

            let createTree = function(pageId: number) {
                let tree: PageData[] = [];
                let sp = subPages[pageId];
                let item: PageData;
                let si: PageData[];
                if (sp) {
                    for (let i = 0; i < sp.length; i++) {
                        item = sp[i];
                        si = createTree(item.pageId);
                        if (si.length) {
                            item.items = si;
                        }
                        tree.push(item);
                    }
                }
                pagesMap[pageId] = tree;
                return tree;
            };
            createTree(0);
            this.pagesMap = pagesMap;
        }

        /**
         * Creates a overlay that will block all
         * hover events on all editor elements
         * Still, jQuery UI Dropable and Sortable will function
         * because of the way they are implemented
         */
        createHoverBlockOverlay() {
            this.hoverBlockOverlay =
                $('<div class="dd-hover-block-overlay"></div>')
                .css('zIndex', this.hoverBlockOverlayZindex)
                .appendTo($('body'))
                .wrap('<div class="diye"></div>')
            ;

        }
        removeHoverBlockOverlay() {
            if (this.hoverBlockOverlay) {
                this.hoverBlockOverlay.unwrap().remove();
            }
        }
        /**
         * Refreshes matrix drop zones if the underlying elements change
         */
        refreshMatrixZones() {
            this.zones.forEach(zone => {
                if (zone instanceof MatrixDropZone) {
                    zone.refresh();
                }
            });
        }
        /**
         * Listens for events that would cause the sources and targets to be refreshed
         */
        setUpRefreshListeners() {
            $(document).on('diy.editor.moduleInitialized', (e, module) => {
                this.refreshMatrixZones();
            });

            $(document).on('diy.editor.navigationDataChanged', (e, navData) => {
                this.prepareNavigationData(navData);
            });
        }
    }

export = ModuleDragDrop;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/DragDrop.ts
 **/